<template>
    <span class="def-price">
        <slot />
    </span>
</template>

<script>
export default {
    name: 'DefPrice',
    selector: '.def-price',
}
</script>

<style lang="scss" scoped>
.def-price{
    font-size: rem(16);
    line-height: 110%;
    font-weight: 600;
}
</style>